import {Injectable} from '@angular/core';
import {CommonService} from './common.service';
import {v1URL} from '../constants/urls.constants';
import {Observable} from 'rxjs';
import {
  FetchNotificationListDetailResponseModel,
  FetchNotificationListResponseModel,
  MarkAsReadNotificationResponseModel,
  NotificationItemModel,
  TriggerNotificationResponseModel
} from '../../page-modules/notifications/model/notification-model';
import {MessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(private commonService: CommonService, private messageService: MessageService) {
  }

  showNotification(data: NotificationItemModel) {
    this.messageService.add({key: 'confirm', sticky: false, ...data, life: 5000});
  }

  fetchNotificationList(payload: { pageNumber?: number, sortOrder?: number, sortColumn?: string, limit?: number, read?: boolean, timestamp?: any }): Observable<FetchNotificationListResponseModel['response']> {
    const urlConfig = v1URL.notification.notificationList;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }


  fetchNotificationDetails(payload: { notificationId: string }): Observable<FetchNotificationListDetailResponseModel['response']> {
    const urlConfig = v1URL.notification.notificationDetails
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.notificationId));
  }

  markNotificationAsRead(payload: { notificationId: string[] }): Observable<MarkAsReadNotificationResponseModel['response']> {
    const urlConfig = v1URL.notification.markNotificationAsRead
    return this.commonService.callAPI(urlConfig.method, urlConfig.url,payload);
  }

  deleteNotificationAsRead(payload: { notificationId: string[] }): Observable<MarkAsReadNotificationResponseModel['response']> {
    const urlConfig = v1URL.notification.deleteNotification
    return this.commonService.callAPI(urlConfig.method, urlConfig.url,payload);
  }

  triggerNotification(payload: TriggerNotificationResponseModel['request']): Observable<TriggerNotificationResponseModel['response']> {
    const urlConfig = v1URL.notification.triggerNotification
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
